import ColorSchema from "../../kits/Color";
import FormulationListItem from "./FormulationListItem";

export default function FormulationList({ data, deactiveFormulation }) {
  console.log("wwwwwwwwwwwwwwwwwwwwwww", data);
  return (
    <div className="formulation-list rounded px-2 py-4 shadow">
      {Object.keys(data).map((value, index) => {
        return (
          <div
            className=" my-2 rounded"
            style={{ border: `1px dashed ${ColorSchema.blue_custom}` }}
          >
            <div
              className="d-inline-block p-1 rounded-top-right text-light"
              style={{
                backgroundColor: ColorSchema.secondary_custom,
                borderTopRightRadius: "0.3rem",
                borderBottomLeftRadius: "0.3rem",
              }}
            >
              گروه {value}
            </div>
            <ul style={{ listStyleType: "disc" }} className="px-4">
              {data[value]?.map((v, i) => (
                <>
                  <FormulationListItem
                    itemData={v}
                    deactiveFormulation={deactiveFormulation}
                  />
                  {i != data[value]?.length - 1 && <hr />}
                </>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
  );
}
